(function($) {
'use strict';

	var ModuleName = 'ntb_gpbt';

	var Module = function ( ele, options ) {
		this.$ele = $(ele);
		this.options = options;
		this.$tabsWrap = this.$ele.children('.ntb_tab');
		this.$tabs = this.$ele.find('.ntb_tab > li');
		this.$contentWrap = this.$ele.children('.contents');
		this.$contents = this.$contentWrap.children('.content');
		this.$nextButton = this.$ele.children('.next');
		this.$prevButton = this.$ele.children('.prev');
	};

	Module.DEFAULTS = {
		tabLable: [

		],
	    whenNext: function($this, $thisTab, tabLabelData) {},
	    whenPrev: function($this, $thisTab, tabLabelData) {},
	    whenClick: function($this, $thisTab, tabLabelData) {}
	};

	Module.prototype.initial = function () {
		console.log('inital');
		if ( this.$tabs.length > 1 ) {
			this.onClickli();
			this.onClickNext();
			this.onClickPrev();
			this.btnSwitcher();
			this.offsetTabPosition();
			this.disableContent();
			this.enbaleContent();
		}
		this.setTabsLable();
	};

	Module.prototype.setTabsLable = function (){
		var self = this;
		if ( $.type(this.options.tabLable) === 'array' && this.options.tabLable.length >= this.$tabs.length ) {
			this.$tabs.each(function(i, ele) {
				$(ele).attr('data-label',self.options.tabLable[i]);
			});			
		} else {
			console.log('Option tabLable must be array!');
		}
	};

	Module.prototype.returnIndexLi = function ( dom ){
		var compareDom;
		if ( !!dom ) {
			if ( dom instanceof $ ) {
				compareDom = dom.get(0);
			} else {
				compareDom = dom;
			}
		} else {
			compareDom = this.$tabs.filter('.now').get(0);
		}
		return this.$tabs.index( compareDom );
	}

	Module.prototype.getTabWidthPercent = function () {
		return this.$tabs.eq(0).width()/this.$tabsWrap.width() * 100;
	};

	Module.prototype.offsetTabPosition = function () {
		var nowIndex = this.returnIndexLi();
		var maxLindex = this.$tabs.length - 1;
		if ( nowIndex > 0 && nowIndex < maxLindex ) {
			this.$tabs.eq(0).css('margin-left', -((nowIndex - 1) * this.getTabWidthPercent()) + '%' );
		}
	};

	Module.prototype.disableContent = function ( i ) {
		this.$contents.hide();
	};

	Module.prototype.enbaleContent = function ( i ) {
		var nowIndex = i || this.returnIndexLi();
		// console.log(nowIndex);
		this.$contents.eq(nowIndex).show();
	};

	Module.prototype.onClickli = function () {
		var _this = this;
		var returnItem;
		var returnContent;
		this.$tabs.on('click',function(e){
			e.preventDefault();
			// console.log('onClick Me!!',this);
			_this.diasbleTabs();
			_this.enableTab( this );	
			_this.options.whenClick(_this.$ele, $(this), _this.options.tabLable[_this.returnIndexLi()]);
			_this.btnSwitcher();
			_this.offsetTabPosition();
			_this.disableContent();
			_this.enbaleContent();
		});
	};

	Module.prototype.diasbleTabs = function () {
		this.$tabs.removeClass('now');
	};

	Module.prototype.enableTab = function ( dom ) {
		$(dom).addClass('now')
	};

	Module.prototype.isFirstLast = function () {
		var returnVal;
		var nowIndex = this.returnIndexLi();
		var maxLindex = this.$tabs.length - 1;
		if ( nowIndex === 0 || nowIndex === maxLindex ) {
			returnVal = nowIndex;
		} else {
			returnVal = false;
		}
		return returnVal;
	};

	Module.prototype.btnSwitcher = function ( ) {
		if ( typeof this.isFirstLast() === 'number' ) {
			if ( this.isFirstLast() === 0 ) {
				this.$prevButton.removeClass('on');
			} else {
				this.$nextButton.removeClass('on');
			}
		} else {
			this.$nextButton.addClass('on');
			this.$prevButton.addClass('on');
		}
	}

	Module.prototype.onClickNext = function() {
		var _this = this;
		this.$ele.find('.next').on('click',function(e){
			// console.log("next");
			e.preventDefault();
			var nowIndex = _this.returnIndexLi();
			var maxLindex = _this.$tabs.length - 1;
			var $nextTab = _this.$tabs.eq( nowIndex + 1 );
			// console.log(nowIndex);
			if ( nowIndex >= 0 && nowIndex < maxLindex ){
				_this.diasbleTabs();
				_this.enableTab($nextTab.get(0));
				_this.options.whenNext(_this.$ele, $nextTab, _this.options.tabLable[_this.returnIndexLi()]);
			}
			_this.btnSwitcher();
			_this.offsetTabPosition();
			_this.disableContent();
			_this.enbaleContent();
		});
	}
	Module.prototype.onClickPrev = function() {
		var _this = this;
		this.$ele.find('.prev').on('click',function(e){
			// console.log("prev");
			e.preventDefault();
			var nowIndex = _this.returnIndexLi();
			var maxLindex = _this.$tabs.length - 1;
			var $prevTab = _this.$tabs.eq( nowIndex - 1 );
			if ( nowIndex > 0 && nowIndex <= maxLindex ){
				_this.diasbleTabs();
				_this.enableTab( $prevTab.get(0) );
				_this.options.whenPrev(_this.$ele, $prevTab, _this.options.tabLable[_this.returnIndexLi()]);
			}
			_this.btnSwitcher();
			_this.offsetTabPosition();
			_this.disableContent();
			_this.enbaleContent();
		});		
	}	
	$.fn[ModuleName] = function ( method, options ) {
		return this.each(function(){
			var $this = $(this);
			var module = $this.data( ModuleName );
			var opts = null;
			if ( !!module ) {
				if ( typeof method === 'string' &&  typeof options === 'undefined' ) {
					module[method]();
				} else if ( typeof method === 'string' && typeof options === 'object' || typeof options === 'string' ) {
					module[method](options);
				} else {
					console.log('unsupported options!');
				}
			} else {
				opts = $.extend( {}, Module.DEFAULTS, ( typeof method === 'object' && method ), ( typeof options === 'object' && options ) );
				module = new Module(this, opts);
				$this.data( ModuleName, module );
				module.initial();
			}
		});
	};

})(jQuery);


// WEBPACK FOOTER //
// ./magaele/ntb_gpbt/module.js